(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('p2ExportProc', {
        templateUrl: 'views/components/views/p2ExportProc/p2ExportProc.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'ediExportService', 'p2ExportProcService', 'p2ImportProcsService', 'tailorAccessesService', 'kpiCompService', function ($stateParams, stateService, ediExportService, p2ExportProcService, p2ImportProcsService, tailorAccessesService, kpiCompService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let p2ExportProcKeyno = $stateParams.p2_exportproc_keyno;

            vm.model = {
                ediDestinationButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.edi_destination_keyno = '0' }
                ],
                webPageButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.p2_webpage_keyno = '0' }
                ],
                tailorAccessButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.tailoraccess_keyno = '0' },
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('tailoraccesses') }
                ],
                edit: {},
                selectListImportProcedures: [],
                selectListEdiDestinations: [],
                selectListTableNames: [],
                selectListWebPages: [],
                selectListTailorAccesses: [],
                selectListEdiTypes: [],
                selectListGridCount: [
                    { item_id: '1', item_name: '1' },
                    { item_id: '2', item_name: '2' },
                    { item_id: '3', item_name: '3' }
                ],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALLS

            async function loadEdit() {
                vm.model.edit = (await p2ExportProcService.getEdit({ p2_exportproc_keyno: p2ExportProcKeyno }))[0];
            }

            async function loadTailorAccesses() {
                vm.model.selectListTailorAccesses = await tailorAccessesService.listTailorAccesses();
            }

            async function loadEdiTypes() {
                vm.model.selectListEdiTypes = await p2ExportProcService.listEdiTypes();
            }

            async function loadImportProcedures() {
                vm.model.selectListImportProcedures = await p2ImportProcsService.listImportProcedures();
            }

            async function loadEdiDestinations() {
                vm.model.selectListEdiDestinations = await ediExportService.listEdiDestinations();
            }

            async function loadTableNames() {
                vm.model.selectListTableNames = await p2ExportProcService.listTableNames();
            }

            async function loadWebpages() {
                vm.model.selectListWebPages = await kpiCompService.listWebpages();
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                p2ExportProcService.saveObj(vm.model.edit).then(() => {
                    vm.model.lockedSave = false;
                    stateService.back();
                }, () => vm.model.lockedSave = false);
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadEdit();
                loadImportProcedures();
                loadEdiDestinations();
                loadEdiTypes();
                loadTableNames();
                loadTailorAccesses();
                loadWebpages();
            };

            // #endregion ON INIT FUNCTION

        }]
    })
})();
